import './polyfill';
import externalLinks from './modules/externalLinks';
import 'alpinejs';
import Swiper from 'swiper';

var mySwiper = new Swiper('.swiper-container', {
  loop: true,
  autoHeight: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoplay: {
    delay: 5000,
  },
});

document.addEventListener('DOMContentLoaded', function () {
  externalLinks();
});

// var mapIsHere = document.getElementById('map');

// if (typeof (mapIsHere) !== 'undefined' && mapIsHere != null) {
//   mapboxgl.accessToken = 'pk.eyJ1IjoiaGluenVuZGt1bnoiLCJhIjoiY2s5ZTB0enFkMDB4MTNncW4zM2Zxdmk5MyJ9.yfSJxqsWDj5KzMKkCzPR6w';
//   var map = new mapboxgl.Map({
//     container: 'map',
//     style: 'mapbox://styles/hinzundkunz/cka56m73b02na1il72c9av937',
//     center: [8.04447, 47.39115],
//     zoom: 16.75,
//     pitch: 35,
//   });

//   map.scrollZoom.disable();
//   map.touchPitch.enable();
//   map.touchZoomRotate.enable();
//   map.dragPan.disable();
//   map.addControl(new mapboxgl.NavigationControl());

//   map.on('load', function () {
//     /* Image: An image is loaded and added to the map. */
//     map.loadImage('/default/img/dot.png', function (error, image) {
//       if (error) throw error;
//       map.addImage('custom-marker', image);
//       /* Style layer: A style layer ties together the source and image and specifies how they are displayed on the map. */
//       map.addLayer({
//         id: 'markers',
//         type: 'symbol',
//         /* Source: A data source specifies the geographic coordinate where the image marker gets placed. */
//         source: {
//           type: 'geojson',
//           data: {
//             type: 'FeatureCollection',
//             features: [{
//               type: 'Feature',
//               properties: {},
//               geometry: {
//                 type: 'Point',
//                 coordinates: [8.04447, 47.39115],
//               },
//             }],
//           },
//         },
//         layout: {
//           'icon-image': 'custom-marker',
//         },
//       });
//     });
//   });
// }
